import { Link } from "react-router-dom";
import { categories, articles } from "@/mocks/articles";

export default function CategorySection() {
  return (
    <section aria-labelledby="category-heading" className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 id="category-heading" className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              按主题翻旧料
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              六个常设栏目，覆盖综艺、影视、创作者、造型、行业与网络热议。
            </p>
          </div>
          <Link
            to="/archive"
            className="whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部存档 →
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat, index) => {
            const count = articles.filter((item) => item.categoryKey === cat.key).length;
            return (
              <Link
                key={cat.key}
                to={`/archive?cat=${cat.key}`}
                className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
              >
                <span
                  className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-xl ${
                    index % 3 === 1
                      ? "bg-accent-100 text-accent-700"
                      : index % 3 === 2
                        ? "bg-secondary-100 text-secondary-700"
                        : "bg-primary-50 text-primary-600"
                  }`}
                >
                  <i className={cat.icon} />
                </span>
                <span className="flex-1">
                  <span className="flex items-center justify-between">
                    <span className="font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                      {cat.name}
                    </span>
                    <span className="text-xs text-foreground-400">{count} 篇</span>
                  </span>
                  <span className="mt-1.5 block text-sm leading-relaxed text-foreground-600">{cat.desc}</span>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}